import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  doc, getDoc, getDocs, updateDoc, collection, addDoc, onSnapshot, deleteDoc, serverTimestamp, query, orderBy
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { paraCevir, AY_ADLARI } from '../utils/takvim';
import { 
  ArrowLeft, CloudSun, Phone, StickyNote, Save, 
  TrendingUp, Calendar, HardHat, Info, Building2, Plus, Trash2, X, 
  Image as ImageIcon, FileText, Clock, User, CheckCircle2, 
  MapPin, Star, Check, ChevronLeft, ChevronRight, Calculator, Wallet,
  Edit3, Bell, BellOff, Grid3X3, Layers, ChevronDown, ChevronUp,
  Package, AlertTriangle, CheckCircle, AlertCircle
} from 'lucide-react';

export default function SantiyeDetay() {
  const { santiyeId } = useParams();
  const navigate = useNavigate();

  const [santiye, setSantiye] = useState(null);
  const [hava, setHava] = useState(null);
  const [analizVerisi, setAnalizVerisi] = useState([]);
  const [ustalar, setUstalar] = useState([]);
  const [form, setForm] = useState({ konum: '', telefon: '', notlar: '' });
  const [yukleniyor, setYukleniyor] = useState(false);
  const [kaydedildi, setKaydedildi] = useState(false);

  const [bloklar, setBloklar] = useState([]);
  const [raporlar, setRaporlar] = useState([]);
  const [expandedBloklar, setExpandedBloklar] = useState({});

  const [blokModal, setBlokModal] = useState(false);
  const [yeniBlokAd, setYeniBlokAd] = useState('');
  const [yeniBlokMetrekare, setYeniBlokMetrekare] = useState('');
  const [blokYukleniyor, setBlokYukleniyor] = useState(false);

  const [parselModal, setParselModal] = useState(false);
  const [parselBlokId, setParselBlokId] = useState(null);
  const [yeniParselAd, setYeniParselAd] = useState('');
  const [yeniParselMetrekare, setYeniParselMetrekare] = useState('');
  const [parselYukleniyor, setParselYukleniyor] = useState(false);

  const [kalemModal, setKalemModal] = useState(false);
  const [seciliBlokId, setSeciliBlokId] = useState(null);
  const [yeniKalemAd, setYeniKalemAd] = useState('');
  const [kalemYukleniyor, setKalemYukleniyor] = useState(false);

  const [raporModal, setRaporModal] = useState(false);
  const [raporDuzenleme, setRaporDuzenleme] = useState(false);
  const [duzenlenecekRaporId, setDuzenlenecekRaporId] = useState(null);
  const [raporForm, setRaporForm] = useState({
    blokId: '', parselId: '', kalemId: '', not: '', resimler: [], durum: 'devam', bildirimDurumu: 'bildirilmedi'
  });
  const [resimYukleniyor, setResimYukleniyor] = useState(false);

  const [aktifSekme, setAktifSekme] = useState('ozet');
  const [raporFiltreBlok, setRaporFiltreBlok] = useState('');

  // Toast Bildirim Sistemi
  const [toast, setToast] = useState(null);
  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!santiyeId) return;
    const fetchUstalar = async () => {
      const snap = await getDocs(collection(db, 'ustalar'));
      setUstalar(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    };
    fetchUstalar();

    const unsub = onSnapshot(doc(db, 'santiyeler', santiyeId), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setSantiye(data);
        setForm({ konum: data.konum || '', telefon: data.telefon || '', notlar: data.notlar || '' });
        if (data.konum) fetchHavaDurumu(data.konum);
      }
    });

    const qBloklar = query(collection(db, 'santiyeler', santiyeId, 'bloklar'), orderBy('olusturmaTarihi', 'desc'));
    const unsubBloklar = onSnapshot(qBloklar, snap => {
      setBloklar(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    const qRaporlar = query(collection(db, 'santiyeler', santiyeId, 'raporlar'), orderBy('tarih', 'desc'));
    const unsubRaporlar = onSnapshot(qRaporlar, snap => {
      setRaporlar(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });

    return () => { unsub(); unsubBloklar(); unsubRaporlar(); };
  }, [santiyeId]);

  useEffect(() => {
    if (santiyeId && ustalar.length > 0) hesaplaSon3Ay();
  }, [santiyeId, ustalar]);

  const hesaplaSon3Ay = async () => {
    const sonuclar = [];
    const bugun = new Date();
    for (let i = 0; i < 3; i++) {
      const d = new Date(bugun.getFullYear(), bugun.getMonth() - i, 1);
      const ayKey = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      const aySnap = await getDoc(doc(db, 'aylikCalisma', ayKey));
      let ayGun = 0, ayMaliyet = 0;
      if (aySnap.exists()) {
        const kayitlar = aySnap.data().kayitlar || {};
        Object.values(kayitlar).forEach(ustaMap => {
          Object.entries(ustaMap).forEach(([uId, sId]) => {
            if (sId === santiyeId) {
              ayGun++;
              const usta = ustalar.find(u => u.id === uId);
              ayMaliyet += Number(usta?.yovmiye || 0);
            }
          });
        });
      }
      sonuclar.push({ etiket: `${AY_ADLARI[d.getMonth()]} ${d.getFullYear()}`, gun: ayGun, maliyet: ayMaliyet });
    }
    setAnalizVerisi(sonuclar);
  };

  const fetchHavaDurumu = async (sehir) => {
    try {
      const API_KEY = "731e8be7f1dd467a8a2120016262804";
      const res = await fetch(`https://api.weatherapi.com/v1/forecast.json?key=${API_KEY}&q=${encodeURIComponent(sehir)}&days=7&lang=tr`);
      const data = await res.json();
      if (data.forecast) setHava(data.forecast.forecastday);
    } catch (err) { console.error(err); }
  };

  const guncelle = async () => {
    setYukleniyor(true);
    await updateDoc(doc(db, 'santiyeler', santiyeId), form);
    setYukleniyor(false);
    setKaydedildi(true);
    setTimeout(() => setKaydedildi(false), 2000);
    if (form.konum) fetchHavaDurumu(form.konum);
  };

  const toggleBlokExpand = (blokId) => {
    setExpandedBloklar(prev => ({ ...prev, [blokId]: !prev[blokId] }));
  };

  const getBlokRaporSayisi = (blokId) => raporlar.filter(r => r.blokId === blokId).length;
  const getBlokTamamlananRaporSayisi = (blokId) => raporlar.filter(r => r.blokId === blokId && r.durum === 'tamam').length;

  const blokEkle = async () => {
    if (!yeniBlokAd.trim()) { showToast('Blok adı girilmeli', 'error'); return; }
    setBlokYukleniyor(true);
    try {
      await addDoc(collection(db, 'santiyeler', santiyeId, 'bloklar'), {
        ad: yeniBlokAd.trim(), metrekare: Number(yeniBlokMetrekare) || 0, kalemler: [], parseller: [], olusturmaTarihi: serverTimestamp()
      });
      setYeniBlokAd(''); setYeniBlokMetrekare(''); setBlokModal(false);
    } catch (err) { console.error('Blok ekleme hatası:', err); showToast('Blok eklenirken hata: ' + err.message, 'error'); }
    finally { setBlokYukleniyor(false); }
  };

  const parselEkle = async () => {
    if (!yeniParselAd.trim() || !parselBlokId) { showToast('Parsel adı girilmeli', 'error'); return; }
    setParselYukleniyor(true);
    try {
      const blokRef = doc(db, 'santiyeler', santiyeId, 'bloklar', parselBlokId);
      const blokSnap = await getDoc(blokRef);
      const mevcutParseller = blokSnap.data().parseller || [];
      await updateDoc(blokRef, {
        parseller: [...mevcutParseller, { id: Date.now().toString(), ad: yeniParselAd.trim(), metrekare: Number(yeniParselMetrekare) || 0 }]
      });
      setYeniParselAd(''); setYeniParselMetrekare(''); setParselModal(false);
    } catch (err) { console.error('Parsel ekleme hatası:', err); showToast('Parsel eklenirken hata: ' + err.message, 'error'); }
    finally { setParselYukleniyor(false); }
  };

  const parselSil = async (blokId, parselId) => {
    const blokRef = doc(db, 'santiyeler', santiyeId, 'bloklar', blokId);
    const blokSnap = await getDoc(blokRef);
    const mevcutParseller = blokSnap.data().parseller || [];
    await updateDoc(blokRef, { parseller: mevcutParseller.filter(p => p.id !== parselId) });
  };

  const kalemEkle = async () => {
    if (!yeniKalemAd.trim() || !seciliBlokId) { showToast('Kalem adı girilmeli', 'error'); return; }
    setKalemYukleniyor(true);
    try {
      const blokRef = doc(db, 'santiyeler', santiyeId, 'bloklar', seciliBlokId);
      const blokSnap = await getDoc(blokRef);
      const mevcutKalemler = blokSnap.data().kalemler || [];
      await updateDoc(blokRef, { kalemler: [...mevcutKalemler, { id: Date.now().toString(), ad: yeniKalemAd.trim() }] });
      setYeniKalemAd(''); setKalemModal(false);
    } catch (err) { console.error('Kalem ekleme hatası:', err); showToast('Kalem eklenirken hata: ' + err.message, 'error'); }
    finally { setKalemYukleniyor(false); }
  };

  const kalemSil = async (blokId, kalemId) => {
    const blokRef = doc(db, 'santiyeler', santiyeId, 'bloklar', blokId);
    const blokSnap = await getDoc(blokRef);
    const mevcutKalemler = blokSnap.data().kalemler || [];
    await updateDoc(blokRef, { kalemler: mevcutKalemler.filter(k => k.id !== kalemId) });
  };

  const blokSil = async (blokId) => {
    if (!confirm('Bu bloğu, tüm parsellerini, kalemlerini ve raporlarını silmek istediğinize emin misiniz?')) return;
    await deleteDoc(doc(db, 'santiyeler', santiyeId, 'bloklar', blokId));
  };

  const resimYukle = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    setResimYukleniyor(true);
    const yeniResimler = [];
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', 'age_uploads');
      formData.append('folder', 'age-crm/raporlar');
      try {
        const res = await fetch('https://api.cloudinary.com/v1_1/dvrxaw1bl/image/upload', { method: 'POST', body: formData });
        const data = await res.json();
        yeniResimler.push(data.secure_url);
      } catch (err) { console.error('Resim yükleme hatası:', err); }
    }
    setRaporForm(prev => ({ ...prev, resimler: [...prev.resimler, ...yeniResimler] }));
    setResimYukleniyor(false);
  };

  const raporOlustur = async () => {
    if (!raporForm.blokId || !raporForm.kalemId) { showToast('Lütfen blok ve iş kalemi seçin', 'error'); return; }
    const seciliBlok = bloklar.find(b => b.id === raporForm.blokId);
    const seciliKalem = seciliBlok?.kalemler?.find(k => k.id === raporForm.kalemId);
    const seciliParsel = raporForm.parselId ? seciliBlok?.parseller?.find(p => p.id === raporForm.parselId) : null;
    const now = new Date();
    await addDoc(collection(db, 'santiyeler', santiyeId, 'raporlar'), {
      blokId: raporForm.blokId, parselId: raporForm.parselId || null, kalemId: raporForm.kalemId,
      blokAd: seciliBlok?.ad || '', parselAd: seciliParsel?.ad || null, kalemAd: seciliKalem?.ad || '',
      not: raporForm.not, resimler: raporForm.resimler, durum: raporForm.durum, bildirimDurumu: raporForm.bildirimDurumu,
      tarih: serverTimestamp(),
      tarihStr: now.toLocaleString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }),
      olusturan: 'Admin'
    });
    setRaporForm({ blokId: '', parselId: '', kalemId: '', not: '', resimler: [], durum: 'devam', bildirimDurumu: 'bildirilmedi' });
    setRaporModal(false);
  };

  const raporDuzenleAc = (rapor) => {
    setRaporDuzenleme(true);
    setDuzenlenecekRaporId(rapor.id);
    setRaporForm({
      blokId: rapor.blokId || '', parselId: rapor.parselId || '', kalemId: rapor.kalemId || '',
      not: rapor.not || '', resimler: rapor.resimler || [], durum: rapor.durum || 'devam', bildirimDurumu: rapor.bildirimDurumu || 'bildirilmedi'
    });
    setRaporModal(true);
  };

  const raporGuncelle = async () => {
    if (!raporForm.blokId || !raporForm.kalemId) { showToast('Lütfen blok ve iş kalemi seçin', 'error'); return; }
    const seciliBlok = bloklar.find(b => b.id === raporForm.blokId);
    const seciliKalem = seciliBlok?.kalemler?.find(k => k.id === raporForm.kalemId);
    const seciliParsel = raporForm.parselId ? seciliBlok?.parseller?.find(p => p.id === raporForm.parselId) : null;
    try {
      await updateDoc(doc(db, 'santiyeler', santiyeId, 'raporlar', duzenlenecekRaporId), {
        blokId: raporForm.blokId, parselId: raporForm.parselId || null, kalemId: raporForm.kalemId,
        blokAd: seciliBlok?.ad || '', parselAd: seciliParsel?.ad || null, kalemAd: seciliKalem?.ad || '',
        not: raporForm.not, resimler: raporForm.resimler, durum: raporForm.durum, bildirimDurumu: raporForm.bildirimDurumu
      });
      setRaporForm({ blokId: '', parselId: '', kalemId: '', not: '', resimler: [], durum: 'devam', bildirimDurumu: 'bildirilmedi' });
      setRaporModal(false); setRaporDuzenleme(false); setDuzenlenecekRaporId(null);
    } catch (err) { console.error('Rapor güncelleme hatası:', err); showToast('Rapor güncellenirken hata: ' + err.message, 'error'); }
  };

  const raporSil = async (raporId) => {
    if (!confirm('Bu raporu silmek istediğinize emin misiniz?')) return;
    await deleteDoc(doc(db, 'santiyeler', santiyeId, 'raporlar', raporId));
  };

  const getRaporlarByBlok = () => {
    const gruplu = {};
    bloklar.forEach(blok => { gruplu[blok.id] = raporlar.filter(r => r.blokId === blok.id); });
    const blokAtanmamis = raporlar.filter(r => !r.blokId || !bloklar.find(b => b.id === r.blokId));
    if (blokAtanmamis.length > 0) gruplu['__diger'] = blokAtanmamis;
    return gruplu;
  };

  const seciliBlok = bloklar.find(b => b.id === raporForm.blokId);

  if (!santiye) {
    return (
      <div className="min-h-screen bg-stone-950 flex items-center justify-center">
        <div className="text-stone-500 animate-pulse text-sm">Yükleniyor...</div>
      </div>
    );
  }

  const durumRenk = (durum) => {
    switch(durum) {
      case 'tamam': return { bg: 'bg-green-500/10', text: 'text-green-400', border: 'border-green-500/20', label: 'Tamamlandı' };
      case 'devam': return { bg: 'bg-yellow-500/10', text: 'text-yellow-400', border: 'border-yellow-500/20', label: 'Devam Ediyor' };
      case 'durak': return { bg: 'bg-red-500/10', text: 'text-red-400', border: 'border-red-500/20', label: 'Duraklatıldı' };
      case 'yapilmadi': return { bg: 'bg-stone-500/10', text: 'text-stone-400', border: 'border-stone-500/20', label: 'Yapılmadı' };
      default: return { bg: 'bg-stone-500/10', text: 'text-stone-400', border: 'border-stone-500/20', label: durum };
    }
  };

  const bildirimRenk = (durum) => {
    return durum === 'bildirildi' 
      ? { bg: 'bg-blue-500/10', text: 'text-blue-400', border: 'border-blue-500/20', icon: Bell, label: 'Bildirildi' }
      : { bg: 'bg-stone-500/10', text: 'text-stone-400', border: 'border-stone-500/20', icon: BellOff, label: 'Bildirilmedi' };
  };

  const toastRenk = (type) => {
    switch(type) {
      case 'error': return 'bg-red-500/90 text-white';
      case 'success': return 'bg-green-500/90 text-white';
      case 'warning': return 'bg-yellow-500/90 text-white';
      default: return 'bg-stone-800/90 text-white';
    }
  };

  return (
    <div className="min-h-screen bg-stone-950 text-white">
      {/* TOAST BİLDİRİM */}
      {toast && (
        <div className={`fixed top-4 left-4 right-4 z-[60] flex items-center justify-center pointer-events-none sm:top-6 sm:left-auto sm:right-6 sm:w-auto`}>
          <div className={`pointer-events-auto flex items-center gap-3 px-5 py-4 rounded-2xl shadow-2xl border max-w-full sm:max-w-md animate-in slide-in-from-top-3 ${
            toast.type === 'error' 
              ? 'bg-red-500/10 border-red-500/20 text-red-400 backdrop-blur-md' 
              : 'bg-green-500/10 border-green-500/20 text-green-400 backdrop-blur-md'
          }`}>
            {toast.type === 'error' ? <AlertCircle size={18} /> : <CheckCircle size={18} />}
            <span className="text-sm font-bold">{toast.message}</span>
            <button onClick={() => setToast(null)} className="ml-2 p-1 rounded-lg hover:bg-white/10 transition-all"><X size={14} /></button>
          </div>
        </div>
      )}
      {/* TOAST NOTIFICATION */}
      {toast && (
        <div className={`fixed top-20 left-1/2 -translate-x-1/2 z-[60] px-6 py-3 rounded-2xl text-sm font-bold shadow-2xl backdrop-blur-md animate-in fade-in slide-in-from-top-2 duration-300 ${toastRenk(toast.type)}`}>
          <div className="flex items-center gap-2">
            {toast.type === 'error' && <AlertTriangle size={16} />}
            {toast.type === 'success' && <CheckCircle2 size={16} />}
            {toast.type === 'warning' && <Bell size={16} />}
            {toast.message}
          </div>
        </div>
      )}

      {/* HEADER */}
      <div className="bg-stone-900 border-b border-stone-800 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-3 md:px-4 py-3 md:py-4">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <button onClick={() => navigate('/admin')} className="p-2.5 md:p-3 bg-stone-950 rounded-xl md:rounded-2xl border border-stone-800 hover:border-stone-600 transition-all active:scale-95 flex-shrink-0">
                <ArrowLeft size={18} className="md:w-5 md:h-5" />
              </button>
              <div className="min-w-0">
                <h1 className="text-base md:text-xl font-black text-white tracking-tight truncate">{santiye.ad}</h1>
                <div className="flex items-center gap-2 mt-0.5">
                   <span className="w-1.5 h-1.5 md:w-2 md:h-2 bg-green-500 rounded-full animate-pulse flex-shrink-0"></span>
                   <p className="text-[9px] md:text-[10px] text-stone-500 uppercase font-bold tracking-widest truncate">Şantiye Canlı İzleme Paneli</p>
                </div>
              </div>
            </div>
            <div className="hidden lg:flex gap-3 flex-shrink-0">
               <div className="bg-stone-900/50 border border-stone-800 px-4 md:px-5 py-2 md:py-2.5 rounded-2xl">
                  <p className="text-[9px] text-stone-500 font-black uppercase">Toplam Mesai (3 Ay)</p>
                  <p className="text-base md:text-lg font-black text-white">{analizVerisi.reduce((a, b) => a + b.gun, 0)} Gün</p>
               </div>
               <div className="bg-stone-900/50 border border-stone-800 px-4 md:px-5 py-2 md:py-2.5 rounded-2xl">
                  <p className="text-[9px] text-stone-500 font-black uppercase">Toplam Maliyet (3 Ay)</p>
                  <p className="text-base md:text-lg font-black text-green-500">{paraCevir(analizVerisi.reduce((a, b) => a + b.maliyet, 0))}</p>
               </div>
            </div>
          </div>
        </div>
      </div>

      {/* SEKMELER */}
      <div className="max-w-6xl mx-auto px-3 md:px-4 mt-4 md:mt-6">
        <div className="flex gap-1 bg-stone-900/50 p-1 rounded-xl md:rounded-2xl border border-stone-800 overflow-x-auto no-scrollbar">
          {[{ id: 'ozet', label: 'Özet & Hava', mobileLabel: 'Özet', icon: CloudSun }, { id: 'bloklar', label: 'Bloklar & Parseller', mobileLabel: 'Bloklar', icon: Grid3X3 }, { id: 'raporlar', label: 'İş Takip Raporları', mobileLabel: 'Raporlar', icon: FileText }].map(s => (
            <button key={s.id} onClick={() => setAktifSekme(s.id)}
              className={`flex-1 flex items-center justify-center gap-1.5 md:gap-2 py-2.5 md:py-3 rounded-lg md:rounded-xl text-[10px] md:text-[11px] font-black uppercase tracking-wider transition-all whitespace-nowrap ${aktifSekme === s.id ? 'bg-stone-800 text-white shadow-md' : 'text-stone-500 hover:text-stone-300 hover:bg-stone-800/30'}`}>
              <s.icon size={14} /> {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-3 md:px-4 py-4 md:py-6 pb-24 md:pb-32">

        {/* ÖZET SEKMESİ */}
        {aktifSekme === 'ozet' && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-8">
            <div className="lg:col-span-2 space-y-8">
              <div className="bg-stone-900 border border-stone-800 rounded-[1.5rem] lg:rounded-[2.5rem] p-5 lg:p-8 relative overflow-hidden group">
                <div className="absolute top-0 right-0 p-10 opacity-10 group-hover:scale-110 transition-transform"><CloudSun size={120} /></div>
                <div className="relative z-10">
                  <div className="flex items-center justify-between mb-8">
                    <h2 className="text-sm font-black uppercase tracking-widest text-blue-400 flex items-center gap-2"><CloudSun size={20} /> Bölgesel Hava Tahmini</h2>
                    <span className="text-[10px] px-4 py-1.5 bg-blue-500/10 text-blue-400 rounded-full border border-blue-500/20 font-bold uppercase">{form.konum || 'Konum Bekleniyor'}</span>
                  </div>
                  <div className="flex gap-4 overflow-x-auto no-scrollbar">
                    {hava ? hava.map((gun, index) => (
                      <div key={index} className="flex-1 min-w-[100px] bg-stone-950/40 border border-stone-800/50 p-5 rounded-3xl text-center backdrop-blur-sm">
                        <p className="text-[10px] text-stone-500 font-black mb-3 uppercase">{index === 0 ? 'Bugün' : new Date(gun.date).toLocaleDateString('tr', {weekday: 'short'})}</p>
                        <img src={gun.day.condition.icon} alt="icon" className="w-10 h-10 lg:w-12 lg:h-12 mx-auto" />
                        <p className="text-lg font-black text-white mt-3">{Math.round(gun.day.avgtemp_c)}°</p>
                        <p className="text-[9px] text-stone-600 font-bold uppercase truncate">{gun.day.condition.text}</p>
                      </div>
                    )) : (
                      <div className="w-full py-10 text-center text-stone-700 italic text-sm">Hava durumu verisi için geçerli bir konum girin.</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="bg-stone-900 border border-stone-800 rounded-[1.5rem] lg:rounded-[2.5rem] overflow-hidden">
                <div className="p-5 lg:p-8 border-b border-stone-800 flex items-center justify-between">
                   <div className="flex items-center gap-3"><div className="p-3 bg-stone-950 rounded-2xl"><TrendingUp size={20} className="text-green-500"/></div><h2 className="text-sm font-black uppercase tracking-widest text-stone-300">İşletme Performansı (Son 3 Ay)</h2></div>
                   <Info size={18} className="text-stone-700" />
                </div>
                <div className="divide-y divide-stone-800">
                  {analizVerisi.length > 0 ? analizVerisi.map((item, i) => (
                    <div key={i} className="group flex flex-col sm:flex-row sm:items-center justify-between p-5 lg:p-8 hover:bg-stone-950/50 transition-all gap-4">
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 flex items-center justify-center bg-stone-900 rounded-2xl border border-stone-800 group-hover:border-stone-600 transition-colors"><Calendar size={20} className="text-stone-500" /></div>
                        <div><p className="text-sm font-black text-stone-200">{item.etiket}</p><p className="text-[10px] text-stone-500 font-bold uppercase tracking-tighter">Ay Sonu Hakediş Özeti</p></div>
                      </div>
                      <div className="flex gap-6 lg:gap-12 items-center w-full sm:w-auto justify-between sm:justify-start">
                        <div className="text-center"><p className="text-xs text-stone-500 font-bold uppercase mb-1">Mesai</p><p className="text-lg font-black text-white">{item.gun} GÜN</p></div>
                        <div className="text-right min-w-[120px]"><p className="text-xs text-stone-500 font-bold uppercase mb-1">Maliyet</p><p className="text-lg font-black text-green-500">{paraCevir(item.maliyet)}</p></div>
                      </div>
                    </div>
                  )) : (
                    <div className="p-10 text-center text-stone-700">Hesaplanmış veri bulunmuyor.</div>
                  )}
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-stone-900 border border-stone-800 rounded-[1.5rem] lg:rounded-[2.5rem] p-5 lg:p-8 shadow-2xl">
                <h2 className="text-xs font-black uppercase tracking-widest text-stone-500 mb-8 flex items-center gap-2"><HardHat size={16} /> Saha Kayıt Bilgileri</h2>
                <div className="space-y-6">
                  <div className="space-y-2">
                    <label className="text-[10px] text-stone-600 uppercase font-black ml-1">İlçe / Şehir</label>
                    <input value={form.konum} onChange={e => setForm({...form, konum: e.target.value})} className="w-full bg-stone-950 border border-stone-800 rounded-2xl px-6 py-4 text-sm outline-none focus:border-stone-500 transition-all placeholder:text-stone-800" placeholder="Örn: Kadıköy" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] text-stone-600 uppercase font-black ml-1 text-stone-400">İletişim Numarası</label>
                    <div className="flex items-center bg-stone-950 border border-stone-800 rounded-2xl px-6">
                      <Phone size={18} className="text-stone-700" />
                      <input value={form.telefon} onChange={e => setForm({...form, telefon: e.target.value})} className="w-full bg-transparent border-none py-4 px-4 text-sm outline-none" placeholder="05xx..." />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] text-stone-600 uppercase font-black ml-1 text-stone-400">Şantiye Notları</label>
                    <div className="flex items-start bg-stone-950 border border-stone-800 rounded-2xl px-6">
                      <StickyNote size={18} className="text-stone-700 mt-5" />
                      <textarea value={form.notlar} onChange={e => setForm({...form, notlar: e.target.value})} className="w-full bg-transparent border-none py-4 px-4 text-sm outline-none min-h-[150px] resize-none" placeholder="Önemli şantiye notları..." />
                    </div>
                  </div>
                  <button onClick={guncelle} disabled={yukleniyor} className="w-full bg-white text-black font-black py-5 rounded-2xl flex items-center justify-center gap-3 hover:bg-stone-200 active:scale-[0.97] transition-all disabled:opacity-50 shadow-xl shadow-white/5">
                    <Save size={22} /> {yukleniyor ? 'İŞLENİYOR...' : 'VERİLERİ GÜNCELLE'}
                  </button>
                  {kaydedildi && (
                    <div className="text-center text-green-400 text-xs font-bold flex items-center justify-center gap-1 animate-bounce"><CheckCircle2 size={14} /> Kaydedildi</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* BLOKLAR SEKMESİ */}
        {aktifSekme === 'bloklar' && (
          <div className="space-y-4 md:space-y-6">
            <div className="flex items-center justify-between">
              <div className="text-[10px] text-stone-500 uppercase font-black tracking-widest">{bloklar.length} Blok</div>
              <button onClick={() => setBlokModal(true)} className="flex items-center gap-1.5 md:gap-2 bg-white text-stone-900 font-bold px-4 md:px-5 py-2 md:py-2.5 rounded-xl md:rounded-2xl text-[11px] md:text-xs hover:bg-stone-200 transition-all active:scale-95"><Plus size={14} /> <span className="hidden sm:inline">Yeni Blok</span><span className="sm:hidden">Blok</span></button>
            </div>

            {bloklar.length === 0 ? (
              <div className="bg-stone-900/50 border border-stone-800 rounded-[2rem] p-12 md:p-16 text-center">
                <Building2 size={32} className="text-stone-700 mx-auto mb-4 md:w-10 md:h-10" />
                <p className="text-stone-500 text-sm font-bold">Henüz blok eklenmemiş</p>
                <p className="text-stone-600 text-xs mt-2">"Yeni Blok" butonu ile başlayın</p>
              </div>
            ) : (
              <div className="space-y-3 md:space-y-4">
                {bloklar.map(blok => {
                  const raporSayisi = getBlokRaporSayisi(blok.id);
                  const tamamlananSayisi = getBlokTamamlananRaporSayisi(blok.id);
                  const isExpanded = expandedBloklar[blok.id];
                  return (
                    <div key={blok.id} className="bg-stone-900 border border-stone-800 rounded-2xl md:rounded-[2rem] overflow-hidden hover:border-stone-700 transition-all">
                      <div onClick={() => toggleBlokExpand(blok.id)} className="p-4 md:p-6 cursor-pointer">
                        <div className="flex items-center gap-3 md:gap-4">
                          <div className="w-10 h-10 md:w-12 md:h-12 bg-stone-800 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0"><Building2 size={18} className="text-stone-400 md:w-5 md:h-5" /></div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center justify-between">
                              <h3 className="text-sm md:text-base font-black text-white truncate">{blok.ad}</h3>
                              <div className="flex items-center gap-1 md:gap-3 flex-shrink-0 ml-2">
                                <div className="flex items-center gap-1 md:gap-2 bg-stone-800/50 px-2 md:px-3 py-1 md:py-2 rounded-lg md:rounded-xl border border-stone-800">
                                  <FileText size={10} className="text-stone-500 md:w-3 md:h-3" />
                                  <span className="text-[9px] md:text-[10px] font-black text-stone-400">{raporSayisi}</span>
                                  {tamamlananSayisi > 0 && <span className="text-[9px] md:text-[10px] font-black text-green-400 hidden sm:inline">({tamamlananSayisi})</span>}
                                </div>
                                <button onClick={(e) => { e.stopPropagation(); toggleBlokExpand(blok.id); }} className="p-1.5 md:p-2 rounded-lg md:rounded-xl bg-stone-800 text-stone-400 hover:text-white transition-all">
                                  {isExpanded ? <ChevronUp size={16} className="md:w-[18px] md:h-[18px]" /> : <ChevronDown size={16} className="md:w-[18px] md:h-[18px]" />}
                                </button>
                                <button onClick={(e) => { e.stopPropagation(); blokSil(blok.id); }} className="p-1.5 md:p-2 rounded-lg md:rounded-xl bg-stone-800 text-stone-400 hover:text-red-400 hover:bg-red-500/10 transition-all" title="Bloğu Sil"><Trash2 size={14} className="md:w-4 md:h-4" /></button>
                              </div>
                            </div>
                            <div className="flex items-center gap-2 md:gap-3 mt-1 flex-wrap">
                              <span className="text-[9px] md:text-[10px] text-stone-500 font-bold">{blok.metrekare || 0} m²</span>
                              <span className="text-[9px] text-stone-600">•</span>
                              <span className="text-[9px] md:text-[10px] text-stone-500 font-bold">{blok.parseller?.length || 0} Parsel</span>
                              <span className="text-[9px] text-stone-600">•</span>
                              <span className="text-[9px] md:text-[10px] text-stone-500 font-bold">{blok.kalemler?.length || 0} Kalem</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {isExpanded && (
                        <div className="px-4 md:px-6 pb-4 md:pb-6 space-y-4 md:space-y-6 border-t border-stone-800/50">
                          <div className="pt-4 md:pt-5">
                            <div className="flex items-center justify-between mb-3">
                              <div className="text-[10px] text-stone-500 uppercase font-black tracking-wider flex items-center gap-2"><Package size={12} /> Parseller</div>
                              <button onClick={() => { setParselBlokId(blok.id); setParselModal(true); }} className="flex items-center gap-1.5 bg-stone-800 text-stone-300 px-2.5 md:px-3 py-1 md:py-1.5 rounded-lg text-[10px] font-bold hover:bg-stone-700 transition-all"><Plus size={12} /> Parsel</button>
                            </div>
                            {blok.parseller?.length > 0 ? (
                              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
                                {blok.parseller.map(parsel => (
                                  <div key={parsel.id} className="bg-stone-950 border border-stone-800 rounded-xl p-2.5 md:p-3 flex items-center justify-between group hover:border-stone-700 transition-all">
                                    <div className="min-w-0"><p className="text-[11px] md:text-xs font-bold text-stone-300 truncate">{parsel.ad}</p><p className="text-[9px] md:text-[10px] text-stone-600">{parsel.metrekare} m²</p></div>
                                    <button onClick={() => parselSil(blok.id, parsel.id)} className="p-1 rounded text-stone-600 hover:text-red-400 transition-all flex-shrink-0 ml-1"><X size={12} /></button>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <p className="text-xs text-stone-600 italic">Henüz parsel eklenmemiş</p>
                            )}
                          </div>

                          <div>
                            <div className="flex items-center justify-between mb-3">
                              <div className="text-[10px] text-stone-500 uppercase font-black tracking-wider flex items-center gap-2"><HardHat size={12} /> İş Kalemleri</div>
                              <button onClick={() => { setSeciliBlokId(blok.id); setKalemModal(true); }} className="flex items-center gap-1.5 bg-stone-800 text-stone-300 px-2.5 md:px-3 py-1 md:py-1.5 rounded-lg text-[10px] font-bold hover:bg-stone-700 transition-all"><Plus size={12} /> Kalem</button>
                            </div>
                            {blok.kalemler?.length > 0 ? (
                              <div className="flex flex-wrap gap-1.5 md:gap-2">
                                {blok.kalemler.map(kalem => (
                                  <span key={kalem.id} className="inline-flex items-center gap-1 md:gap-1.5 bg-stone-950 text-stone-300 text-[10px] md:text-[11px] px-2.5 md:px-3 py-1.5 md:py-2 rounded-lg md:rounded-xl border border-stone-800">
                                    {kalem.ad}
                                    <button onClick={() => kalemSil(blok.id, kalem.id)} className="text-stone-600 hover:text-red-400 transition-colors"><X size={10} /></button>
                                  </span>
                                ))}
                              </div>
                            ) : (
                              <p className="text-xs text-stone-600 italic">Henüz iş kalemi eklenmemiş</p>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* RAPORLAR SEKMESİ */}
        {aktifSekme === 'raporlar' && (
          <div className="space-y-4 md:space-y-6">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 md:gap-4 min-w-0">
                <div className="text-[10px] text-stone-500 uppercase font-black tracking-widest flex-shrink-0">{raporlar.length} Rapor</div>
                <select value={raporFiltreBlok} onChange={e => setRaporFiltreBlok(e.target.value)} className="bg-stone-900 border border-stone-800 text-stone-300 text-[10px] px-2 md:px-3 py-1.5 md:py-2 rounded-lg outline-none focus:border-stone-600 min-w-0">
                  <option value="">Tüm Bloklar</option>
                  {bloklar.map(b => (<option key={b.id} value={b.id}>{b.ad}</option>))}
                </select>
              </div>
              <button onClick={() => { setRaporDuzenleme(false); setDuzenlenecekRaporId(null); setRaporForm({ blokId: '', parselId: '', kalemId: '', not: '', resimler: [], durum: 'devam', bildirimDurumu: 'bildirilmedi' }); setRaporModal(true); }} className="flex items-center gap-1.5 md:gap-2 bg-white text-stone-900 font-bold px-3 md:px-5 py-2 md:py-2.5 rounded-xl md:rounded-2xl text-[11px] md:text-xs hover:bg-stone-200 transition-all active:scale-95 flex-shrink-0"><FileText size={14} /> <span className="hidden sm:inline">Yeni Rapor</span><span className="sm:hidden">Rapor</span></button>
            </div>

            {raporlar.length === 0 ? (
              <div className="bg-stone-900/50 border border-stone-800 rounded-[2rem] p-12 md:p-16 text-center">
                <FileText size={32} className="text-stone-700 mx-auto mb-4 md:w-10 md:h-10" />
                <p className="text-stone-500 text-sm font-bold">Henüz rapor oluşturulmamış</p>
                <p className="text-stone-600 text-xs mt-2">Blok ve iş kalemleri ekledikten sonra rapor oluşturabilirsiniz</p>
              </div>
            ) : (
              <div className="space-y-6 md:space-y-8">
                {(() => {
                  const grupluRaporlar = getRaporlarByBlok();
                  const filtrelenmisBloklar = raporFiltreBlok ? bloklar.filter(b => b.id === raporFiltreBlok) : bloklar;
                  return filtrelenmisBloklar.map(blok => {
                    const blokRaporlari = grupluRaporlar[blok.id] || [];
                    if (blokRaporlari.length === 0) return null;
                    return (
                      <div key={blok.id} className="space-y-3 md:space-y-4">
                        <div className="flex items-center gap-2 md:gap-3 pb-2 border-b border-stone-800">
                          <Building2 size={14} className="text-stone-500 md:w-4 md:h-4" />
                          <h3 className="text-xs md:text-sm font-black text-white">{blok.ad}</h3>
                          <span className="text-[9px] md:text-[10px] bg-stone-800 text-stone-400 px-2 py-1 rounded-lg font-bold">{blokRaporlari.length} Rapor</span>
                        </div>
                        <div className="space-y-3 md:space-y-4">
                          {blokRaporlari.map(rapor => {
                            const durum = durumRenk(rapor.durum);
                            const bildirim = bildirimRenk(rapor.bildirimDurumu);
                            const BildirimIcon = bildirim.icon;
                            return (
                              <div key={rapor.id} className="bg-stone-900 border border-stone-800 rounded-2xl md:rounded-[2rem] p-4 md:p-6 space-y-3 md:space-y-4 hover:border-stone-700 transition-all">
                                <div className="flex items-start justify-between gap-2">
                                  <div className="flex items-center gap-2 md:gap-3 min-w-0">
                                    <div className={`w-2 md:w-2.5 h-2 md:h-2.5 rounded-full flex-shrink-0 mt-1 ${rapor.durum === 'tamam' ? 'bg-green-500' : rapor.durum === 'devam' ? 'bg-yellow-500' : rapor.durum === 'durak' ? 'bg-red-500' : 'bg-stone-500'}`} />
                                    <div className="min-w-0">
                                      <h3 className="text-xs md:text-sm font-black text-white truncate">{rapor.kalemAd}{rapor.parselAd && <span className="text-stone-500 font-normal"> — {rapor.parselAd}</span>}</h3>
                                      <div className="flex items-center gap-2 md:gap-4 mt-1 md:mt-1.5 text-[9px] md:text-[10px] text-stone-500 font-bold flex-wrap">
                                        <span className="flex items-center gap-1"><Calendar size={10} /> {rapor.tarihStr?.split(' ')[0]}</span>
                                        <span className="flex items-center gap-1"><Clock size={10} /> {rapor.tarihStr?.split(' ')[1]}</span>
                                        <span className="flex items-center gap-1 hidden sm:flex"><User size={10} /> {rapor.olusturan}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex gap-1 md:gap-1.5 flex-shrink-0">
                                    <button onClick={() => raporDuzenleAc(rapor)} className="p-2 md:p-2.5 rounded-lg md:rounded-xl bg-stone-800 text-stone-400 hover:text-white hover:bg-stone-700 transition-all" title="Düzenle"><Edit3 size={12} className="md:w-[14px] md:h-[14px]" /></button>
                                    <button onClick={() => raporSil(rapor.id)} className="p-2 md:p-2.5 rounded-lg md:rounded-xl bg-stone-800 text-stone-400 hover:text-red-400 hover:bg-red-500/10 transition-all" title="Sil"><Trash2 size={12} className="md:w-[14px] md:h-[14px]" /></button>
                                  </div>
                                </div>
                                {rapor.not && (
                                  <div className="bg-stone-950/50 rounded-xl p-3 md:p-4 border border-stone-800/30"><p className="text-xs text-stone-300 leading-relaxed">{rapor.not}</p></div>
                                )}
                                {rapor.resimler?.length > 0 && (
                                  <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2">
                                    {rapor.resimler.map((url, idx) => (
                                      <a key={idx} href={url} target="_blank" rel="noopener noreferrer" className="aspect-square rounded-lg md:rounded-xl overflow-hidden border border-stone-800 hover:border-stone-600 transition-all">
                                        <img src={url} alt={`Rapor ${idx + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform" />
                                      </a>
                                    ))}
                                  </div>
                                )}
                                <div className="flex items-center gap-2 flex-wrap">
                                  <span className={`text-[9px] md:text-[10px] font-black uppercase px-2 md:px-3 py-1 md:py-1.5 rounded-lg ${durum.bg} ${durum.text} border ${durum.border}`}>{durum.label}</span>
                                  <span className={`text-[9px] md:text-[10px] font-black uppercase px-2 md:px-3 py-1 md:py-1.5 rounded-lg flex items-center gap-1 ${bildirim.bg} ${bildirim.text} border ${bildirim.border}`}><BildirimIcon size={10} /> {bildirim.label}</span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>
            )}
          </div>
        )}
      </div>

      {/* MOBIL BOTTOM SHEET / DESKTOP MODAL */}
      {blokModal && (
        <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/70 backdrop-blur-sm p-0 md:p-4" onClick={() => setBlokModal(false)}>
          <div className="bg-stone-900 border border-stone-800 rounded-t-[2rem] md:rounded-[2rem] p-6 md:p-8 w-full max-w-md space-y-4 md:space-y-5 shadow-2xl animate-in slide-in-from-bottom-5 md:animate-none" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-black text-white uppercase tracking-wider">Yeni Blok Ekle</h3>
              <button type="button" onClick={() => setBlokModal(false)} className="text-stone-500 hover:text-white p-2 rounded-xl hover:bg-stone-800 transition-all"><X size={18} /></button>
            </div>
            <div className="space-y-4">
              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Blok Adı</label>
                <input value={yeniBlokAd} onChange={e => setYeniBlokAd(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); blokEkle(); } }} placeholder="Örn: A Blok" className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all placeholder:text-stone-800" />
              </div>
              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Metrekare (m²)</label>
                <input type="number" value={yeniBlokMetrekare} onChange={e => setYeniBlokMetrekare(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); blokEkle(); } }} placeholder="1200" className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all placeholder:text-stone-800" />
              </div>
            </div>
            <div className="flex gap-3 pt-2 pb-2 md:pb-0">
              <button type="button" onClick={() => setBlokModal(false)} className="flex-1 py-3.5 md:py-4 rounded-2xl text-xs font-black text-stone-400 hover:bg-stone-800 transition-all uppercase tracking-wider">İptal</button>
              <button type="button" onClick={blokEkle} disabled={blokYukleniyor} className="flex-1 bg-white text-stone-900 py-3.5 md:py-4 rounded-2xl text-xs font-black hover:bg-stone-200 transition-all disabled:opacity-40 uppercase tracking-wider">{blokYukleniyor ? 'Ekleniyor...' : 'Ekle'}</button>
            </div>
          </div>
        </div>
      )}

      {parselModal && (
        <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/70 backdrop-blur-sm p-0 md:p-4" onClick={() => setParselModal(false)}>
          <div className="bg-stone-900 border border-stone-800 rounded-t-[2rem] md:rounded-[2rem] p-6 md:p-8 w-full max-w-md space-y-4 md:space-y-5 shadow-2xl animate-in slide-in-from-bottom-5 md:animate-none" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-black text-white uppercase tracking-wider">Yeni Parsel Ekle</h3>
              <button type="button" onClick={() => setParselModal(false)} className="text-stone-500 hover:text-white p-2 rounded-xl hover:bg-stone-800 transition-all"><X size={18} /></button>
            </div>
            <div className="space-y-4">
              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Parsel Adı</label>
                <input value={yeniParselAd} onChange={e => setYeniParselAd(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); parselEkle(); } }} placeholder="Örn: Parsel 1" className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all placeholder:text-stone-800" />
              </div>
              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Metrekare (m²)</label>
                <input type="number" value={yeniParselMetrekare} onChange={e => setYeniParselMetrekare(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); parselEkle(); } }} placeholder="400" className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all placeholder:text-stone-800" />
              </div>
            </div>
            <div className="flex gap-3 pt-2 pb-2 md:pb-0">
              <button type="button" onClick={() => setParselModal(false)} className="flex-1 py-3.5 md:py-4 rounded-2xl text-xs font-black text-stone-400 hover:bg-stone-800 transition-all uppercase tracking-wider">İptal</button>
              <button type="button" onClick={parselEkle} disabled={parselYukleniyor} className="flex-1 bg-white text-stone-900 py-3.5 md:py-4 rounded-2xl text-xs font-black hover:bg-stone-200 transition-all disabled:opacity-40 uppercase tracking-wider">{parselYukleniyor ? 'Ekleniyor...' : 'Ekle'}</button>
            </div>
          </div>
        </div>
      )}

      {kalemModal && (
        <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/70 backdrop-blur-sm p-0 md:p-4" onClick={() => setKalemModal(false)}>
          <div className="bg-stone-900 border border-stone-800 rounded-t-[2rem] md:rounded-[2rem] p-6 md:p-8 w-full max-w-md space-y-4 md:space-y-5 shadow-2xl animate-in slide-in-from-bottom-5 md:animate-none" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-black text-white uppercase tracking-wider">İş Kalemi Ekle</h3>
              <button type="button" onClick={() => setKalemModal(false)} className="text-stone-500 hover:text-white p-2 rounded-xl hover:bg-stone-800 transition-all"><X size={18} /></button>
            </div>
            <div>
              <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Kalem Adı</label>
              <input value={yeniKalemAd} onChange={e => setYeniKalemAd(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); kalemEkle(); } }} placeholder="Örn: Temel Betonu, Perde İzolasyonu..." className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all placeholder:text-stone-800" />
            </div>
            <div className="flex gap-3 pt-2 pb-2 md:pb-0">
              <button type="button" onClick={() => setKalemModal(false)} className="flex-1 py-3.5 md:py-4 rounded-2xl text-xs font-black text-stone-400 hover:bg-stone-800 transition-all uppercase tracking-wider">İptal</button>
              <button type="button" onClick={kalemEkle} disabled={kalemYukleniyor} className="flex-1 bg-white text-stone-900 py-3.5 md:py-4 rounded-2xl text-xs font-black hover:bg-stone-200 transition-all disabled:opacity-40 uppercase tracking-wider">{kalemYukleniyor ? 'Ekleniyor...' : 'Ekle'}</button>
            </div>
          </div>
        </div>
      )}

      {raporModal && (
        <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/70 backdrop-blur-sm p-0 md:p-4 overflow-y-auto" onClick={() => { setRaporModal(false); setRaporDuzenleme(false); setDuzenlenecekRaporId(null); }}>
          <div className="bg-stone-900 border border-stone-800 rounded-t-[2rem] md:rounded-[2rem] p-6 md:p-8 w-full max-w-lg space-y-4 md:space-y-5 shadow-2xl my-0 md:my-auto animate-in slide-in-from-bottom-5 md:animate-none max-h-[90vh] md:max-h-none overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-black text-white uppercase tracking-wider">{raporDuzenleme ? 'Raporu Düzenle' : 'Yeni Rapor Oluştur'}</h3>
              <button type="button" onClick={() => { setRaporModal(false); setRaporDuzenleme(false); setDuzenlenecekRaporId(null); }} className="text-stone-500 hover:text-white p-2 rounded-xl hover:bg-stone-800 transition-all"><X size={18} /></button>
            </div>

            <div className="space-y-4 md:space-y-5">
              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Blok Seçin *</label>
                <select value={raporForm.blokId} onChange={e => setRaporForm({...raporForm, blokId: e.target.value, parselId: '', kalemId: ''})} className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all appearance-none">
                  <option value="" className="bg-stone-900">Blok seçin...</option>
                  {bloklar.map(b => (<option key={b.id} value={b.id} className="bg-stone-900">{b.ad} ({b.metrekare}m²)</option>))}
                </select>
              </div>

              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Parsel (Opsiyonel)</label>
                <select value={raporForm.parselId} onChange={e => setRaporForm({...raporForm, parselId: e.target.value})} disabled={!raporForm.blokId} className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all disabled:opacity-40 appearance-none">
                  <option value="" className="bg-stone-900">Tüm blok için (parsel seçilmedi)...</option>
                  {seciliBlok?.parseller?.map(p => (<option key={p.id} value={p.id} className="bg-stone-900">{p.ad} ({p.metrekare}m²)</option>))}
                </select>
              </div>

              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">İş Kalemi *</label>
                <select value={raporForm.kalemId} onChange={e => setRaporForm({...raporForm, kalemId: e.target.value})} disabled={!raporForm.blokId} className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all disabled:opacity-40 appearance-none">
                  <option value="" className="bg-stone-900">İş kalemi seçin...</option>
                  {seciliBlok?.kalemler?.map(k => (<option key={k.id} value={k.id} className="bg-stone-900">{k.ad}</option>))}
                </select>
              </div>

              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">İş Durumu</label>
                <div className="grid grid-cols-2 gap-2">
                  {[{ id: 'devam', label: 'Devam', color: 'yellow' }, { id: 'tamam', label: 'Tamam', color: 'green' }, { id: 'durak', label: 'Durak', color: 'red' }, { id: 'yapilmadi', label: 'Yapılmadı', color: 'stone' }].map(d => (
                    <button key={d.id} type="button" onClick={() => setRaporForm({...raporForm, durum: d.id})} className={`py-2.5 md:py-3 rounded-xl text-[10px] font-black uppercase tracking-wider transition-all ${raporForm.durum === d.id ? `bg-${d.color}-500/20 text-${d.color}-400 border border-${d.color}-500/30` : 'bg-stone-950 text-stone-500 border border-stone-800 hover:border-stone-600'}`}>{d.label}</button>
                  ))}
                </div>
              </div>

              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Bildirim Durumu</label>
                <div className="flex gap-2">
                  {[{ id: 'bildirilmedi', label: 'Bildirilmedi', icon: BellOff, color: 'stone' }, { id: 'bildirildi', label: 'Bildirildi', icon: Bell, color: 'blue' }].map(d => {
                    const Icon = d.icon;
                    return (
                      <button key={d.id} type="button" onClick={() => setRaporForm({...raporForm, bildirimDurumu: d.id})} className={`flex-1 py-2.5 md:py-3 rounded-xl text-[10px] font-black uppercase tracking-wider transition-all flex items-center justify-center gap-2 ${raporForm.bildirimDurumu === d.id ? `bg-${d.color}-500/20 text-${d.color}-400 border border-${d.color}-500/30` : 'bg-stone-950 text-stone-500 border border-stone-800 hover:border-stone-600'}`}>
                        <Icon size={12} /> {d.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">İş Notu</label>
                <textarea value={raporForm.not} onChange={e => setRaporForm({...raporForm, not: e.target.value})} rows={3} placeholder="Yapılan iş hakkında detaylı not..." className="w-full bg-stone-950 border border-stone-800 text-white px-4 md:px-5 py-3.5 md:py-4 rounded-2xl text-sm outline-none focus:border-stone-500 transition-all placeholder:text-stone-800 resize-none" />
              </div>

              <div>
                <label className="text-[10px] text-stone-500 uppercase font-black tracking-wider mb-2 block">Rapor Resimleri</label>
                <div className="flex items-center gap-3">
                  <label className="flex items-center gap-2 bg-stone-950 text-stone-300 px-4 md:px-5 py-2.5 md:py-3 rounded-2xl text-xs font-black cursor-pointer hover:bg-stone-800 transition-all border border-stone-800 hover:border-stone-600">
                    <ImageIcon size={14} />
                    {resimYukleniyor ? 'Yükleniyor...' : 'Resim Seç'}
                    <input type="file" multiple accept="image/*" onChange={resimYukle} className="hidden" disabled={resimYukleniyor} />
                  </label>
                  <span className="text-[10px] text-stone-600 font-bold">{raporForm.resimler.length} resim</span>
                </div>
                {raporForm.resimler.length > 0 && (
                  <div className="grid grid-cols-4 gap-2 mt-3">
                    {raporForm.resimler.map((url, idx) => (
                      <div key={idx} className="relative aspect-square rounded-xl overflow-hidden border border-stone-800">
                        <img src={url} alt={`Seçilen ${idx + 1}`} className="w-full h-full object-cover" />
                        <button type="button" onClick={() => setRaporForm(prev => ({...prev, resimler: prev.resimler.filter((_, i) => i !== idx)}))} className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1 hover:bg-red-500 transition-all"><X size={10} /></button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="bg-stone-950/50 rounded-xl p-3 md:p-4 border border-stone-800/50">
                <div className="flex items-center gap-2 text-[10px] text-stone-500 font-bold">
                  <Calendar size={12} />
                  <span>Otomatik Tarih: {new Date().toLocaleString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                </div>
              </div>
            </div>

            <div className="flex gap-3 pt-2 pb-4 md:pb-0">
              <button type="button" onClick={() => { setRaporModal(false); setRaporDuzenleme(false); setDuzenlenecekRaporId(null); }} className="flex-1 py-3.5 md:py-4 rounded-2xl text-xs font-black text-stone-400 hover:bg-stone-800 transition-all uppercase tracking-wider">İptal</button>
              <button type="button" onClick={raporDuzenleme ? raporGuncelle : raporOlustur} disabled={resimYukleniyor} className="flex-1 bg-white text-stone-900 py-3.5 md:py-4 rounded-2xl text-xs font-black hover:bg-stone-200 transition-all disabled:opacity-40 uppercase tracking-wider">
                {raporDuzenleme ? 'Güncelle' : 'Rapor Oluştur'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}